export interface RateGrid {
  issuePhysical: number
  issueVirtual: number
  shipUnit: number
  shipGrouped: number
  loadFlat: number
  loadPct: number
}

export const RATE_GRID_KEYS: (keyof RateGrid)[] = [
  'issuePhysical',
  'issueVirtual',
  'shipUnit',
  'shipGrouped',
  'loadFlat',
  'loadPct'
]

export interface StandardRates extends RateGrid {
  id: string
}

export interface NegotiatedRates extends RateGrid {
  id: string
  caretakerId: string
  caretakerName: string
  validUntil: string
}

export type AllocationKind = 'multi' | 'mono' | 'both'
export type MappingStatus = 'active' | 'draft'
export type DotationType = 'multi' | 'mono'
export type CardKind = 'physical' | 'virtual'

export interface ProgramMapping {
  family: string
  privipassCode: string
  allocationKind: AllocationKind
  ceiling: number | null
  validityMonths: number
  status: MappingStatus
}

export interface LoadTransaction {
  id: string
  idDistribution: string
  caretakerId: string
  caretakerName: string
  programFamily: string
  dotationOrder: string
  dotationType: DotationType
  dotationDate: string
  loadDate: string
  loadRef: string
  expiry: string
  amount: number
  beneficiary: string
  cardId: string
  remaining: number
  coverage: number
  loadCost?: number | null
  negotiated?: boolean
}

export interface IssueTransaction {
  id: string
  cardId: string
  caretakerId: string
  caretakerName: string
  dotationOrder: string
  beneficiary: string
  issueDate: string
  cardNumber: string
  expiry: string
  cardType: CardKind
  coverage: number
  issuePrice?: number | null
  negotiated?: boolean
}

export interface LoadFilters {
  caretakerId?: string
  caretakerName?: string
  dateFrom?: string
  dateTo?: string
  idDistribution?: string
  dotationOrder?: string
  beneficiary?: string
  cardId?: string
  page: number
  per: number
}

export interface IssueFilters {
  caretakerId?: string
  caretakerName?: string
  dateFrom?: string
  dateTo?: string
  cardId?: string
  dotationOrder?: string
  beneficiary?: string
  page: number
  per: number
}

export interface LoadStats {
  totalLoaded: number
  totalRemaining: number
  totalLoadCost: number
  cardsCount: number
  filteredCount: number
  totalCount: number
}

export interface IssueStats {
  cardsIssued: number
  physicalCount: number
  virtualCount: number
  totalIssueCost: number
  filteredCount: number
  totalCount: number
}

export interface ResolvedCost {
  value: number
  negotiated: boolean
  caretakerShare: number
}

export interface LoadRow extends LoadTransaction {
  cost: ResolvedCost
}

export interface IssueRow extends IssueTransaction {
  cost: ResolvedCost
}

export interface LoadListResult {
  data: LoadRow[]
  stats: LoadStats
}

export interface IssueListResult {
  data: IssueRow[]
  stats: IssueStats
}
